import ProviderStatus from "./ProviderStatus";

export default class ProviderModel {

    constructor(public providerId: string, public providerName: string, public lastUpdate: Date, public providerStatus: ProviderStatus, public retirementStatus:ProviderStatus, public activeCourseCount: number) {
    }
}